import '@ionic/react/css/core.css';
// import '@ionic/react/css/ionic-swiper.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/virtual';

import LogoLoader from './components/AnimatedLoader/LogoLoader';
import ErrorBoundaryComponent from './components/ErrorBoundaryComponent';
import { loadFonts } from './utils/appUtils';

const MobileApp = lazy(() => import('./app'));

const Loader = (
  <div>
    <LogoLoader />
  </div>
);

// Error boundary for app initialization
const AppErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundaryComponent>
      {children}
    </ErrorBoundaryComponent>
  );
};

const App = () => {
  return (
    <AppErrorBoundary>
      <ErrorBoundaryComponent>
        <Suspense fallback={Loader}>
          <MobileApp />
        </Suspense>
      </ErrorBoundaryComponent>
      <ToastContainer position="bottom-center" />
    </AppErrorBoundary>
  );
};

const renderMobileApp = async () => {
  try {
    // Add global error handlers for production
    window.addEventListener('error', (event) => {
      console.error('Global error caught:', event.error);
      // Don't prevent default - let error boundaries handle it
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the default behavior to avoid console errors
      event.preventDefault();
    });

    await loadFonts();
    const rootElement = document.getElementById('root');
    if (rootElement) {
      const root = createRoot(rootElement);
      root.render(<App />);
    } else {
      console.error('Root element not found');
    }
  } catch (error) {
    console.error('Failed to render app:', error);
    // Fallback rendering without fonts
    const rootElement = document.getElementById('root');
    if (rootElement) {
      const root = createRoot(rootElement);
      root.render(<App />);
    }
  }
};

renderMobileApp();
